module.exports = __webpack_public_path__ + "static/img/3.258b38e9.png";